"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EqualIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var equal = function equal(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 2.34983V0H12V2.34983H0ZM0 8V5.65016H12V8H0Z",
    fill: "currentColor"
  }));
};
equal.defaultProps = {
  width: "12",
  height: "8",
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var EqualIcon = _styledComponents.default.div.attrs(function () {
  return {
    children: /*#__PURE__*/_react.default.createElement(_ui.Svg, {
      as: equal,
      color: "primary"
    })
  };
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: flex-start;\n  margin: 34px 16px 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.lightPrimary;
});
exports.EqualIcon = EqualIcon;